import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Header from "./Components/Header/Header";
import ProductPage from "./Components/ProductPage/ProductPage";

function App() {
    const [cookies, setCookie] = useCookies(["cart"]);
    const [cart, setCart] = useState(cookies.cart || []);

    useEffect(() => {
        setCookie("cart", cart, { maxAge: 3600 });
    }, [cart]);

    return (
        <React.Fragment>
            <Header cart={cart} setCart={setCart}/>
            <ProductPage cart={cart} setCart={setCart} />
        </React.Fragment>
    );
}

export default App;
